import * as React from 'react';
import { connect } from 'react-redux';
import SolrService from '../../services/SolrService';
import SignalRService from '../../signalRController';

class Solr extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            message: ""
        };

        this.triggerRebuild = this.triggerRebuild.bind(this);
    }

    private emptyState() {
        return {
            message: ""
        };
    }

    triggerRebuild = async () => {
        this.setState({ message: "index rebuild triggered!" });
        await SolrService.rebuild();
    }

    componentDidMount = () => {
        SignalRService.registerReceiveEvent("RebuildIndex",
            (msg) => {
                this.setState({ message: msg.Message });
            }
        );
    }

    componentWillUnmount() {
        SignalRService.unRegisterReceiveEvent("RebuildIndex");
    }

    public render() {
        const { message } = this.state;
        return (
            <React.Fragment>
                <div className="container">
                    <div className="row">
                        <div className="col-sm-12">
                            <button className="btn" onClick={this.triggerRebuild}>Rebuild Index</button> {message}
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
};

export default connect()(Solr);
